import { defineMessages } from 'react-intl';

export const scope = 'components.NavigationLogicActionButton';

export default defineMessages({
  addAdvancedLogic: {
    id: `${scope}.addAdvancedLogic`,
    defaultMessage: 'Add advanced logic',
  },
});
